export const HOME_ACTIONS = [
  {
    icon: {
      type: 'store-circled',
      width: '48px',
      height: '48px',
    },
    title: 'Create a store',
    subtitle:
      'With Swell, you can sell anything. Physical, digital, bundles, and gift card items created with a few clicks.',
    button: {
      action: 'Create store',
      link: '/stores',
      isInternalLink: true,
      align: 'top',
    },
  },
  {
    icon: {
      type: 'apps-circled',
      width: '48px',
      height: '48px',
    },
    title: 'Create an app',
    subtitle:
      'Apps can make schema changes, implement admin workflows, run custom logic, extend APIs, and add extra functionality to any store.',
    button: {
      action: 'Create app',
      link: '/apps',
      isInternalLink: true,
      align: 'top',
    },
  },
  {
    title: 'Documentation',
    actions: [
      {
        title: 'Backend API reference',
        subtitle: 'Learn about our backend API reference for developers',
        button: {
          action: 'Learn more',
          link: 'https://developers.swell.is/backend-api/introduction',
        },
      },
      {
        title: 'Frontend API reference',
        subtitle: 'Learn about our frontend API reference for developers',
        button: {
          action: 'Learn more',
          link: 'https://developers.swell.is/frontend-api/introduction',
        },
      },
      {
        title: 'Quickstart',
        subtitle: 'Learn the basics of building Swell apps',
        button: {
          action: 'Get started',
          link: 'https://developers.swell.is/guides/quickstart-guide',
        },
      },
      {
        title: 'App tutorial',
        subtitle:
          'Learn how to create a product review app with a step-by-step tutorial',
        button: {
          action: 'Read the guide',
          link: 'https://github.com/swellstores/honest-reviews-app',
        },
      },
      {
        title: 'CLI reference',
        subtitle: 'Use the Swell CLI to manage stores and apps',
        button: {
          action: 'Read the docs',
          link: 'https://developers.swell.is/guides/swell-cli',
        },
      },
    ],
  },
  {
    title: 'Join the community',
    actions: [
      {
        icon: {
          type: 'social/github',
          width: '32px',
          height: '32px',
        },
        title: 'Github',
        subtitle: 'Engage with the Swell developer community',
        button: {
          action: 'Join the community',
          link: 'https://github.com/orgs/swellstores/discussions',
        },
      },
    ],
  },
];
